import {ClaimDTO} from './ClaimDTO';
import {MembershipDTO} from './MembershipDTO';
import {ClaimTotalsDTO} from './ClaimTotalsDTO';
import {LineDTO} from './LineDTO';
import {ClaimDiagnosisDTO} from './ClaimDiagnosisDTO';
import {DocumentDTO} from './DocumentDTO';

export class Request {
  Claim: ClaimDTO;
  Membership: MembershipDTO;
  ClaimTotals: ClaimTotalsDTO;
  Line: LineDTO[];
  Diagnosis: ClaimDiagnosisDTO[];
  Document: DocumentDTO[];
}
